import { useLayoutEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

import Make from './../components/MakeSection/Make';
import Titles from '../components/Titles/Titles';
import WorkProjectsList from '../components/WorkProjectsList/WorkProjectsList';
import SEO from '../components/SEO/SEO';
import { usePageSEO } from '../hooks/usePageSEO';

const Work = () => {
    const seo = usePageSEO('work');
    const location = useLocation();

    const isRestoredRef = useRef(false);
    const rafRef = useRef(null);
    const saveQueuedRef = useRef(false);
    const lastScrollRef = useRef(0);
    const [contentReady, setContentReady] = useState(false);

    useLayoutEffect(() => {
        if (typeof window === "undefined") return;
        if (!window.sessionStorage) return;
        if (!contentReady) return;

        const key = `scroll-${location.key}`;

        isRestoredRef.current = false;
        saveQueuedRef.current = false;

        const saved = sessionStorage.getItem(key);

        const restore = () => {
            if (isRestoredRef.current) return;
            isRestoredRef.current = true;

            const y = saved ? parseInt(saved, 10) || 0 : 0;
            window.scrollTo(0, y);
        };

        rafRef.current = requestAnimationFrame(() => {
            rafRef.current = requestAnimationFrame(restore);
        });

        const onScroll = () => {
            if (!isRestoredRef.current) return;

            lastScrollRef.current = window.scrollY || 0;

            if (saveQueuedRef.current) return;
            saveQueuedRef.current = true;

            requestAnimationFrame(() => {
                sessionStorage.setItem(
                    key,
                    String(lastScrollRef.current)
                );

                saveQueuedRef.current = false;
            });
        };

        window.addEventListener("scroll", onScroll, { passive: true });

        return () => {
            window.removeEventListener("scroll", onScroll);

            if (rafRef.current) {
                cancelAnimationFrame(rafRef.current);
            }

            sessionStorage.setItem(
                key,
                String(window.scrollY || 0)
            );
        };
    }, [location.key, contentReady]);

    return (
        <>
            <SEO
                title={seo.title}
                description={seo.description}
                keywords={seo.keywords}
                type={seo.type}
                noIndex={seo.noIndex}
                noFollow={seo.noFollow}
            />
            <Titles page="WorkPage" />
            <WorkProjectsList onReady={() => setContentReady(true)} />
            <Make pageKey="WorkPage" />
        </>
    );
};

export default Work;